import React, { useContext, useEffect, useState } from "react";
import Utils from "../../utils";
import AuthUtil from "../../utils/auth";
import { UserContext } from "../../context";
import CustomModal from "../../../src/components/modal";
import { UserOutlined } from "@ant-design/icons";
import {
  faSignOut,
  faUserCircle,
  faEnvelope,
  faPhone,
  faBuilding,
  faIdCard,
  faLock,
  faCog,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { Avatar } from "antd";
import styles from "./layout-header.module.css";
import GenericPopover from "../pop-over";
import { TContext, TUser } from "../../types/config";
import SendOTP from "../../pages/auth/reset-password";

export default function UserProfile() {
  const context: TContext = useContext(UserContext);
  const [userDetails, setUserDetails] = useState<TUser>(context?.user as TUser);
  const navigate = useNavigate();
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  useEffect(() => {
    setUserDetails(context?.user as TUser);
  }, [context.user]);

  function signOut() {
    AuthUtil.logout();
    Utils.redirectUrl(`/login`);
  }

  const handleSettingsClick = () => {
    navigate("/dashboard/settings");
  };

  const handlePasswordClick = () => {
    setIsPasswordModalOpen(true);
  };

  const handleModalCancel = () => {
    setIsPasswordModalOpen(false);
  };

  const PopoverContent = () => (
    <div className={styles.userBox}>
      <div className={styles.pencil}>
        <Avatar
          size={80}
          style={{
            backgroundColor: "var(--light-primary)",
            color: "var(--bs-primary-dark)",
          }}
          icon={<UserOutlined />}
        >
          {userDetails?.displayName || ""}
        </Avatar>
        <span className={styles.userName}>
          {userDetails?.displayName
            ? userDetails?.displayName
            : userDetails?.emailId}
        </span>
      </div>
      <div className={styles.userProfile}>
        <div className={styles.profileWrapper}>
          <FontAwesomeIcon
            icon={faEnvelope}
            style={{ fontSize: "1.2rem", color: "var(--bs-dark)" }}
          />
          <span>{userDetails?.emailId}</span>
        </div>
        <div className={styles.profileWrapper}>
          <FontAwesomeIcon
            icon={faPhone}
            style={{ fontSize: "1.2rem", color: "var(--bs-dark)" }}
          />
          <span>{userDetails?.mobileNo}</span>
        </div>
        <div className={styles.profileWrapper}>
          <FontAwesomeIcon
            icon={faBuilding}
            style={{ fontSize: "1.2rem", color: "var(--bs-dark)" }}
          />
          <span>{userDetails?.orgName}</span>
        </div>
        <div className={styles.profileWrapper}>
          <FontAwesomeIcon
            icon={faIdCard}
            style={{ fontSize: "1.2rem", color: "var(--bs-dark)" }}
          />
          <span>{userDetails?.roles?.[0]?.name}</span>
        </div>
        <div
          className={styles.profileWrapper}
          onClick={handlePasswordClick}
          style={{ cursor: "pointer" }}
        >
          <FontAwesomeIcon
            icon={faLock}
            style={{ fontSize: "1.2rem", color: "var(--bs-dark)" }}
          />
          <span>Change Password</span>
        </div>
        <div
          className={styles.profileWrapper}
          style={{ cursor: "pointer" }}
          onClick={handleSettingsClick}
        >
          <FontAwesomeIcon
            icon={faCog}
            style={{ fontSize: "1.2rem", color: "var(--bs-dark)" }}
          />
          <span>Settings</span>
        </div>
        <div
          className={styles.profileWrapper}
          style={{ cursor: "pointer", borderBottom: "none" }}
          onClick={signOut}
        >
          <FontAwesomeIcon
            icon={faSignOut}
            style={{ fontSize: "1.2rem", color: "var(--bs-dark)" }}
          />
          <span>Sign Out</span>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <GenericPopover
        placement="bottomLeft"
        content={<PopoverContent />}
        icon={
          <FontAwesomeIcon
            icon={faUserCircle}
            style={{ color: "var(--bs-dark)" }}
            size="2xl"
          />
        }
      />
      <CustomModal
        title="Change Password"
        isOpen={isPasswordModalOpen}
        onOk={() => {}}
        onCancel={handleModalCancel}
        hideOkButton={true}
        hideCancelButton={true}
        okText=""
        cancelText=""
        // width="31%"
        style={{ maxWidth: "90%", minWidth: "300px" }}
      >
        <SendOTP handleModalCancel={handleModalCancel} />
      </CustomModal>
    </>
  );
}
